import { render, staticRenderFns } from "./kurama-loader.vue?vue&type=template&id=400ae163&scoped=true&"
import script from "./kurama-loader.vue?vue&type=script&lang=js&"
export * from "./kurama-loader.vue?vue&type=script&lang=js&"
import style0 from "./kurama-loader.vue?vue&type=style&index=0&id=400ae163&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400ae163",
  null
  
)

export default component.exports